import { HTTPError } from 'ky';

import { fastApi } from '@/services/api';
import type { Identity } from './schema';

export * from './schema';

const PATH = 'v1/customer/form/personal-identity';

type IdentityGetResponse = Identity;

export const getIdentity = async () => {
  return fastApi
    .get(PATH)
    .json<IdentityGetResponse>()
    .catch((error) => {
      if (error instanceof HTTPError && error.response.status === 404) return null;

      throw error;
    });
};

export type IdentityPostRequestBody = {
  answers: Identity;
};

export const postIdentity = async (data: Identity) => {
  return fastApi.post(PATH, {
    json: { answers: data } satisfies IdentityPostRequestBody,
  });
};
